import React from "react";
import Link from "next/link";
import { Box, SxProps, Theme } from "@mui/material";
import MailRoundedIcon from "@mui/icons-material/MailRounded";

const MailIconButton: React.FC<{ sx?: SxProps<Theme> }> = ({ sx }) => {
  return (
    <Link
      target="_blank"
      rel="nofollow noreferrer"
      href="mailto:info@worldcruisevibes.com"
      aria-label="Email us at info@worldcruisevibes.com"
    >
      <Box
        sx={{
          border: "3px solid #FFE3BE",
          bgcolor: "#fff",
          p: "4px",
          borderRadius: "30px",
          display: "grid",
          placeItems: "center",
          ...sx,
        }}
      >
        <Box
          sx={{
            border: "3.9px solid #FF9500",
            bgcolor: "#fff",
            borderRadius: "30px",
            display: "grid",
            placeItems: "center",
            width: "46px",
            height: "46px",
            svg: {
              width: "28px",
              height: "28px",
              color: "#FF8800",
              display: "grid",
              placeItems: "center",
              pb: "1px",
            },
          }}
        >
          <MailRoundedIcon />
        </Box>
      </Box>
    </Link>
  );
};

export default MailIconButton;
